import React from "react";
import { TrackServiceType } from "./TrackFinancialModels";
import { TrackServiceModel } from "../../../../../api/useMusicApi";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import _ from "lodash";

type Props = {
  activeService: TrackServiceType;
  activeServiceModel: TrackServiceModel;
  onChange: (value: TrackServiceModel, activeService: TrackServiceType) => void;
};

export const TrackFinancialModelApplier: React.FC<Props> = ({
                                                              activeServiceModel,
                                                              activeService,
                                                              onChange
                                                            }) => {
  const { t } = useTranslation();
  const handleApplyForService = (service: TrackServiceType) => {
    const clonedActiveServiceModel = _.cloneDeep(activeServiceModel);
    delete clonedActiveServiceModel.clip;
    delete clonedActiveServiceModel.story;
    
    onChange(clonedActiveServiceModel, service);
    toast.success(
      t("success_apply_setup_for_other_service", {
        activeService: t(activeService),
        toCopyService: t(service)
      })
    );
  };

  return (
    <>
      <div className={"flex flex-col w-full"}>
        <div className={"font-bold mb-2"}>Применить даты и территории для:</div>
        {Object.keys(TrackServiceType)
          .filter(
            (s) =>
              ![
                activeService,
                TrackServiceType.BUNDLE,
                TrackServiceType.BLOCK
              ].includes(s as any)
          )
          .map((s) => (
            <div
              key={s}
              className={"cursor-pointer"}
              onClick={() => handleApplyForService(s as TrackServiceType)}
            >
              <FontAwesomeIcon
                icon={faPlus}
                size={"sm"}
                className={"text-muted mr-1"}
              />
              <span className={"font-bold"}>{t(s)}</span>
            </div>
          ))}
      </div>
    </>
  );
};
